import {
  SET_PRODUCT_DETAILS,
  RESET_PRODUCT_DETAIL,
  GET_PDP_SIZE_CHART,
  HANDLE_SIZE_SELECTION
} from "../constants";

import { Product } from "@/services/productService";

type ProductDetailsState = {
  productDetail?: Product;
  sizeChart: any[];
  sizeSelection: boolean;
};

const initialState: ProductDetailsState = {
  productDetail: null,
  sizeChart: [],
  sizeSelection: false
};

const getProductDetail = (state: ProductDetailsState, { productDetail }) => ({
  ...state,
  productDetail
});

const getSizeChart = (state: ProductDetailsState, { data }) => ({
  ...state,
  sizeChart: [...data]
});

const resetProductDetail = () => ({ ...initialState });

const handleSizeSelection = (state: ProductDetailsState, { value }) => ({
  ...state,
  sizeSelection: value
});

const productDetailReducer = (
  state: ProductDetailsState = initialState,
  action
): ProductDetailsState => {
  switch (action.type) {
    case SET_PRODUCT_DETAILS:
      return getProductDetail(state, action);
    case RESET_PRODUCT_DETAIL:
      return resetProductDetail();
    case GET_PDP_SIZE_CHART:
      return getSizeChart(state, action);
    case HANDLE_SIZE_SELECTION:
      return handleSizeSelection(state, action);
    default:
      return state;
  }
};

export default productDetailReducer;
